<template lang="pug">
keep-alive
  .res1.res
    .title {{ $t('reservation.res1.title') }}
    //flex(:height="52")
    .content
      date-picker(@picked="onPicked", @reset="onReset")
    //flex(:height="86")
    //- .bottom
    //-   primary-btn(type="nextStep" @clicked="onNext" :active="picked")
</template>
<script>
import DatePicker from "@/components/res/DatePicker";
import Flex from "@/components/Flex";
import { mapMutations, mapState, mapActions } from "vuex";
// import PrimaryBtn from '@/components/wedgits/PrimaryBtn'
import AlipayService from "@/services/AlipayService";
export default {
  name: "Res1",
  components: { Flex, DatePicker },
  props: {},
  created() {
    console.log("res1 created");
    //let prod = process.env.NODE_ENV === 'production'
    // if (prod) {
    //   if (this.user.faceInfoRegistered) {
    //     // AlipayService.sendMessage({
    //     //   msg: AlipayService.Events.SCHEDULES_REQUEST,
    //     // })
    //     this.GetCalenders()
    //   } else {
    //     AlipayService.sendMessage({
    //       msg: AlipayService.Events.FACE_INFO_REQUEST,
    //     })
    //   }
    //   AlipayService.on(AlipayService.Events.ONMESSAGE, this.onMessage)
    // } else {
    //   this.GetCalenders()
    //   // setTimeout(() => {
    //   //   this.setScheduleTable(this.rawMock)
    //   // }, 2000)
    // }
    //this.GetCalenders()
  },
  data() {
    return {
      rawMock: [
        {
          scheduleId: "1590627600000-1590638400000",
          scheduleDate: "2020-05-27",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590638400000-1590649200000",
          scheduleDate: "2020-05-27",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590649200000-1590660000000",
          scheduleDate: "2020-05-27",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590660000000-1590674400000",
          scheduleDate: "2020-05-27",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590714000000-1590724800000",
          scheduleDate: "2020-05-28",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590724800000-1590735600000",
          scheduleDate: "2020-05-28",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590735600000-1590746400000",
          scheduleDate: "2020-05-28",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590746400000-1590760800000",
          scheduleDate: "2020-05-28",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590800400000-1590811200000",
          scheduleDate: "2020-05-29",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590811200000-1590822000000",
          scheduleDate: "2020-05-29",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590822000000-1590832800000",
          scheduleDate: "2020-05-29",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590832800000-1590847200000",
          scheduleDate: "2020-05-29",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590886800000-1590897600000",
          scheduleDate: "2020-05-30",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590897600000-1590908400000",
          scheduleDate: "2020-05-30",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590908400000-1590919200000",
          scheduleDate: "2020-05-30",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590919200000-1590933600000",
          scheduleDate: "2020-05-30",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590973200000-1590984000000",
          scheduleDate: "2020-05-31",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590984000000-1590994800000",
          scheduleDate: "2020-05-31",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1590994800000-1591005600000",
          scheduleDate: "2020-05-31",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1591005600000-1591020000000",
          scheduleDate: "2020-05-31",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1591059600000-1591070400000",
          scheduleDate: "2020-06-01",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1591070400000-1591081200000",
          scheduleDate: "2020-06-01",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1591081200000-1591092000000",
          scheduleDate: "2020-06-01",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1591092000000-1591106400000",
          scheduleDate: "2020-06-01",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1591146000000-1591156800000",
          scheduleDate: "2020-06-02",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1591156800000-1591167600000",
          scheduleDate: "2020-06-02",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1591167600000-1591178400000",
          scheduleDate: "2020-06-02",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
        {
          scheduleId: "1591178400000-1591192800000",
          scheduleDate: "2020-06-02",
          scheduleQuota: 256,
          scheduleStatus: 0,
        },
      ],
      timeTable: [],
      picked: false,
      active: false,
    };
  },
  computed: {
    ...mapState("app", ["user", "calenders"]),
  },
  watch: {
    // scheduleTable(val) {
    //   if (val.length > 0) {
    //     this.active = true
    //   }
    // },
    // calenders(val) {
    //   if (val.length > 0) {
    //     this.active = true
    //   }
    // },
  },
  methods: {
    ...mapMutations("app", [
      "setRouterBack",
      "setScheduleTable",
      "setSchedulePicked",
    ]),
    //...mapActions('app', ['GetCalenders']),
    onPicked(s) {
      var that = this;
      this.setSchedulePicked(s);
      this.onPicked = true;
      setTimeout(() => {
        that.setRouterBack("/reservation/res1");
        that.$router.replace("/reservation/res2");
      }, 500);
    },
    onReset() {
      this.picked = false;
    },
    // onNext() {
    //   this.setRouterBack('/reservation/res1')
    //   this.$router.replace('/reservation/res2')
    // },
    onMessage(e) {
      // if (e.msg === AlipayService.Events.SCHEDULES) {
      //   this.setScheduleTable(e.schedules)
      // }
    },
  },
  mounted() {},
};
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
@import "src/styles/res.sass"
.res1
  .content
    margin-top: 0
  .wrapper
    width: 100%
    height: 100%

.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(-100%)
</style>
